import { createActions } from 'redux-actions';

export const {
  getExecutorById,
  getExecutorByIdSuccess,
  getExecutorByIdFailure,
  createExecutor,
  createExecutorSuccess,
  createExecutorError,
  updateExecutor,
  updateExecutorSuccess,
  updateExecutorError,
  deleteExecutor,
  deleteExecutorSuccess,
  deleteExecutorError,
  restoreArchiveExecutor,
  restoreArchiveExecutorSuccess,
  restoreArchiveExecutorError,
} = createActions(
  'GET_EXECUTOR_BY_ID',
  'GET_EXECUTOR_BY_ID_SUCCESS',
  'GET_EXECUTOR_BY_ID_FAILURE',
  'CREATE_EXECUTOR',
  'CREATE_EXECUTOR_SUCCESS',
  'CREATE_EXECUTOR_ERROR',
  'UPDATE_EXECUTOR',
  'UPDATE_EXECUTOR_SUCCESS',
  'UPDATE_EXECUTOR_ERROR',
  'DELETE_EXECUTOR',
  'DELETE_EXECUTOR_SUCCESS',
  'DELETE_EXECUTOR_ERROR',
  'RESTORE_ARCHIVE_EXECUTOR',
  'RESTORE_ARCHIVE_EXECUTOR_SUCCESS',
  'RESTORE_ARCHIVE_EXECUTOR_ERROR'
);
